import { GenericBottomSheetTakeoverFragment } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const bottomSheetTakeovers = gql`
  query FetchBottomSheetTakeovers($filter: BottomSheetTakeoversFilterInput!) {
    bottomSheetTakeovers(filter: $filter) {
      __typename
      ...GenericBottomSheetTakeoverFragment
    }
  }
  ${GenericBottomSheetTakeoverFragment}
`;

export default bottomSheetTakeovers;
